import { useApp } from "@/context/AppContext";
import { t } from "@/lib/i18n";
import { Button } from "@/components/ui/button";

export default function AgeWarningModal() {
  const { ageAccepted, acceptAge, sourceLang } = useApp();
  if (ageAccepted) return null;
  // Primary language follows the active source collection: ES for Spanish, NO for Norwegian.
  const primary = sourceLang === "es" ? "es" : "no";

  return (
    <div
      data-testid="age-warning-modal"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-gray-900/70 backdrop-blur-md p-4"
    >
      <div className="relative max-w-xl w-full bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-2xl rise">
        <div className="relative h-40 overflow-hidden grain">
          <img
            src="https://images.unsplash.com/photo-1761156254622-7b66649b1f69?crop=entropy&cs=srgb&fm=jpg&w=1200&q=70"
            alt=""
            className="absolute inset-0 w-full h-full object-cover opacity-90"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-white/0 to-white" />
          <div className="relative h-full flex items-end p-6">
            <span className="text-[10px] tracking-eyebrow text-gray-700 font-medium">
              18+ · explicit content
            </span>
          </div>
        </div>
        <div className="p-8 sm:p-10">
          <h2 className="font-serif-display text-4xl sm:text-5xl tracking-tight text-gray-900 leading-none">
            {t("age_modal_title", primary)}
          </h2>
          <p className="mt-4 text-base sm:text-lg text-gray-700 leading-relaxed">
            {t("age_modal_body", primary)}
          </p>
          <div className="mt-5 pt-5 border-t border-gray-200">
            <h3 className="font-serif-display text-2xl sm:text-3xl tracking-tight text-gray-900 leading-none">
              {t("age_modal_title", "en")}
            </h3>
            <p className="mt-3 text-sm sm:text-base text-gray-600 leading-relaxed">
              {t("age_modal_body", "en")}
            </p>
          </div>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <Button
              data-testid="age-accept-btn"
              onClick={acceptAge}
              className="rounded-full bg-[#E85D04] hover:bg-[#DC2F02] text-white px-6 py-6 text-base font-medium flex-1"
            >
              {t("age_accept", primary)} · {t("age_accept", "en")}
            </Button>
            <Button
              data-testid="age-leave-btn"
              variant="outline"
              onClick={() => {
                window.location.href = "https://www.google.com";
              }}
              className="rounded-full border-gray-300 text-gray-700 px-6 py-6 text-base"
            >
              {t("age_leave", primary)} · {t("age_leave", "en")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
